/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-weather-sleet': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M63.999 64.941V60.56a7.987 7.987 0 003.999-6.92A8 8 0 0060 45.641c-1.601 0-3.084.48-4.334 1.291-1.231-5.317-5.974-9.29-11.665-9.29-6.626 0-11.998 5.372-11.998 11.998 0 3.55 1.55 6.728 3.999 8.925v4.916c-4.776-2.768-7.998-7.922-7.998-13.841 0-8.835 7.162-15.997 15.997-15.997 6.004 0 11.229 3.311 13.966 8.203.663-.113 1.336-.205 2.033-.205 6.626 0 11.998 5.372 11.998 11.999 0 5.223-3.342 9.653-7.999 11.301zm-21.997.698c-1.104 0-1-.895-1-1.998v-8c0-1.104-.104-2 1-2s1 .896 1 2v8c0 1.103.104 1.998-1 1.998zm0 4a2 2 0 11-.002 4 2 2 0 01.002-4zm7.999 0c-1.104 0-1-.895-1-2v-7.998c0-1.105-.104-2 1-2s1 .895 1 2v7.998c0 1.105.104 2-1 2zm0 4a2 2 0 110 3.998 2 2 0 010-3.998zm7.999-8c-1.104 0-1-.895-1-1.998v-8c0-1.104-.104-2 1-2s1 .896 1 2v8c0 1.103.104 1.998-1 1.998zm0 4a2 2 0 11-.001 4.001A2 2 0 0158 69.64z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-weather-sleet.js